import { createApp, watch } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "normalize.css";
import "element-plus/dist/index.css";
import "./assets/style/global.styl";
import './assets/js/flexible'

import "./components/element/index";


import ElementPlus from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import EdiTable from "./components/editable/EdiTable.vue";
import ViewTable from "./components/viewtable/ViewTable.vue";
import SelectTable from "./components/selecttable/SelectTable.vue";

import api from "./api/index";
import bus from "./plugins/bus";
// 挂载原型
window.$api = api;
window.$gb = bus;
const app = createApp(App);

app.use(ElementPlus, {
  locale: zhCn,
});

app.component("EdiTable", EdiTable);
app.component("ViewTable", ViewTable);
app.component("SelectTable", SelectTable);
app.use(store).use(router).mount("#app");
